// extracted by mini-css-extract-plugin
export default {"termsContainer":"Terms_termsContainer__8JZE1","title":"Terms_title__zJCXw","subtitle":"Terms_subtitle__9Y-j+"};